export default __webpack_public_path__ + "static/media/WF.cecb62cc.png";